import React, { useState, useEffect } from 'react';
import Searchbar from '../../components/Search';
import useApiGet from '../hooks/getData';
import RoomMembers from './RoomMembers';
import NoData from '../../assets/NoData.png';
import { useSelector } from 'react-redux';
import RoomGiftHistory from './RoomGiftHistory';

function ChatRoom() {
  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [total, setTotal] = useState(0);

  const [membersOpen, setMembersOpen] = useState(false);
  const [selectedRoom, setSelectedRoom] = useState(null);

  const [historyOpen, setHistoryOpen] = useState(false);
   const [historyRoom, setHistoryRoom] = useState(null);

  const { getData } = useApiGet();
  const isSidebarOpen = useSelector((state) => state.sidebar.isOpen);

  const fetchRooms = async (pageNo) => {
    setLoading(true);
    try {
      const res = await getData('/rooms/', { page: pageNo });
      const roomData = res?.data?.rooms;
      setRooms(roomData?.data || []);
      setLastPage(roomData?.last_page || 1);
      setTotal(roomData?.total || 0);
    } catch (err) {
      console.error("Error fetching rooms:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRooms(page);
  }, [page]);

  const openMembers = (room) => {
    setSelectedRoom(room);
    setMembersOpen(true);
  };

  const formatDate = (d) => {
    if (!d) return "-";
    const date = new Date(d.replace(" ", "T"));
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: '2-digit' });
  };

  return (
    <>
      <div className={`dark:bg-primary ${isSidebarOpen ? "xl:pl-20" : "xl:pl-72"}`}>
        <Searchbar />
        <div className="px-4 pb-10 xl:px-6">

          <div className="flex items-center justify-between py-3">
            <h2 className="text-[#000000] font-poppins text-xl font-semibold pt-3 dark:text-darkText">
              Chat Rooms
            </h2>
            <span className="mt-3 px-3 py-1 text-sm font-poppins text-[#593A99] bg-[#593A99] bg-opacity-10 rounded-lg">
              Total: {total}
            </span>
          </div>

          {loading ? (
            <div className="flex justify-center py-20">
              <p className="font-poppins text-[#000000] dark:text-darkText">Loading...</p>
            </div>
          ) : rooms.length > 0 ? (
            <>
              <div className="mt-4 overflow-hidden bg-white border border-gray-200 dark:bg-primary dark:border-[#1F1F1F] rounded-xl">

                {/* Header */}
                <div className="flex items-center px-6 py-4 bg-[#00000005] dark:bg-[#1F1F1F] text-[#5B5B5B] dark:text-tableDarkLarge font-poppins text-sm font-semibold">
                  <div className="w-[6%]">#</div>
                  <div className="w-[22%]">Room Name</div>
                  <div className="w-[18%]">Host</div>
                  <div className="w-[12%] text-center">Status</div>
                  <div className="w-[10%] text-center">Viewers</div>
                  <div className="w-[10%] text-center">Gifts</div>
                  <div className="w-[12%]">Created</div>
                  <div className="w-[10%] text-center">Action</div>
                </div>

                {/* Rows */}
                {rooms.map((room, index) => (
                  <div
                    key={room.id}
                    className="flex items-center px-6 py-4 border-t border-gray-100 dark:border-[#1F1F1F] hover:bg-[#00000003] dark:hover:bg-[#161616]"
                  >
                    <div className="w-[6%] font-poppins text-sm text-[#777777] dark:text-tableDarkLarge">
                      {(page - 1) * 20 + index + 1}
                    </div>
                    <div className="w-[22%] font-poppins text-sm font-medium text-[#00162e] dark:text-darkText truncate pr-2">
                      {room.name || `Room #${room.id}`}
                    </div>
                    <div className="w-[18%] font-poppins text-sm text-[#5B5B5B] dark:text-tableDarkLarge truncate pr-2">
                      {room.host_name || "-"}
                    </div>
                    <div className="w-[12%] text-center">
                      {room.is_live === 1 ? (
                        <span className="px-3 py-1 text-xs font-medium text-[#0D9947] bg-[#0D9947] bg-opacity-15 rounded-full font-poppins">
                          ● Live
                        </span>
                      ) : (
                        <span className="px-3 py-1 text-xs font-medium text-[#999999] bg-[#999999] bg-opacity-15 rounded-full font-poppins">
                          Ended
                        </span>
                      )}
                    </div>
                    <div className="w-[10%] text-center font-poppins text-sm dark:text-darkText">
                      {room.viewer_count ?? 0}
                    </div>
                    <div className="w-[10%] text-center">
                      <span className="px-2 py-1 text-xs font-semibold text-[#E89A00] bg-[#E89A00] bg-opacity-15 rounded-md font-poppins">
                        {room.total_gifts_received ?? 0}
                      </span>
                    </div>
                    <div className="w-[12%] font-poppins text-xs text-[#777777] dark:text-tableDarkLarge">
                      {formatDate(room.created_at)}
                    </div>
                    <div className="w-[10%] text-center">
                                           <button
                        onClick={() => openMembers(room)}
                        style={{ backgroundColor: '#593A99', color: '#FFFFFF' }}
                        className="px-4 py-2 text-xs font-medium rounded-lg font-poppins whitespace-nowrap hover:opacity-90"
                      >
                        Members
                      </button>
                      <button
                            onClick={() => { setHistoryRoom(room); setHistoryOpen(true); }}
                            style={{ backgroundColor: '#E89A00', color: '#FFFFFF' }}
                            className="px-4 py-2 text-xs font-medium rounded-lg font-poppins whitespace-nowrap hover:opacity-90 ml-2"
                          >
                            History
                          </button>
                    </div>
                  </div>
                ))}
              </div>

              {/* Pagination */}
              <div className="flex items-center justify-center gap-2 mt-6">
                <button
                  disabled={page === 1}
                  onClick={() => setPage(page - 1)}
                  className="px-4 py-2 text-sm border rounded-lg font-poppins border-gray-300 dark:border-[#1F1F1F] dark:text-darkText disabled:opacity-40"
                >
                  Previous
                </button>
                <span className="px-4 text-sm font-poppins dark:text-darkText">
                  Page {page} of {lastPage}
                </span>
                <button
                  disabled={page >= lastPage}
                  onClick={() => setPage(page + 1)}
                  className="px-4 py-2 text-sm border rounded-lg font-poppins border-gray-300 dark:border-[#1F1F1F] dark:text-darkText disabled:opacity-40"
                >
                  Next
                </button>
              </div>
            </>
          ) : (
            <div className="flex flex-col items-center justify-center py-32">
              <img src={NoData} alt="no data" className="w-96" />
              <h2 className="text-sm font-semibold font-poppins text-[#000000]">
                Don't have any data to show
              </h2>
            </div>
          )}
        </div>
      </div>

      <RoomMembers
        open={membersOpen}
        handleClose={() => setMembersOpen(false)}
        room={selectedRoom}
      />
      <RoomGiftHistory open={historyOpen} handleClose={() => setHistoryOpen(false)} room={historyRoom} />
    </>
  );
}

export default ChatRoom;